import { render, staticRenderFns } from "./edit_uuid.vue?vue&type=template&id=1130b654&scoped=true&"
import script from "./edit_uuid.vue?vue&type=script&lang=js&"
export * from "./edit_uuid.vue?vue&type=script&lang=js&"
import style0 from "./edit_uuid.vue?vue&type=style&index=0&id=1130b654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130b654",
  null
  
)

export default component.exports